import { makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';
import { NextTheme } from '../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  option: {
    fontSize: 14,
    overflowWrap: 'anywhere',
  },
  link: {
    color: `${Colors.primaryDark} !important`,
    cursor: 'pointer',
    overflow: 'hidden',
    textDecoration: 'initial !important',
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
}));
